/* eslint-disable sort-keys-fix/sort-keys-fix */
import DOMPurify from 'dompurify';

export const RICH_TEXT_SANITIZE_CONFIG = {
  ALLOWED_ATTR: [
    // Basic attributes
    'id',
    'class',
    'style',
    // Links
    'href',
    'target',
    'rel',
    // Images
    'src',
    'alt',
    'width',
    'height',
    // Tables
    'align',
    'valign',
    'colspan',
    'rowspan',
    // Text formatting
    'color',
    'bgcolor',
    'data-mce-style',
    // Indentation and alignment
    'dir',
    'margin',
    'margin-left',
  ],
  ALLOWED_STYLES: {
    '*': {
      'background-color': [/.*/],
      border: [/.*/],
      color: [/.*/],
      display: [/.*/],
      'font-family': [/.*/],
      'font-size': [/.*/],
      'font-style': [/.*/],
      'font-weight': [/.*/],
      height: [/.*/],
      'letter-spacing': [/.*/],
      margin: [/.*/],
      'margin-top': [/.*/],
      'margin-right': [/.*/],
      'margin-bottom': [/.*/],
      'margin-left': [/.*/],
      padding: [/.*/],
      'padding-top': [/.*/],
      'padding-right': [/.*/],
      'padding-bottom': [/.*/],
      'padding-left': [/.*/],
      'text-align': [/.*/],
      'text-decoration': [/.*/],
      'text-decoration-line': [/.*/],
      'text-transform': [/.*/],
      width: [/.*/],
    },
  },
  ALLOWED_TAGS: [
    // Basic formatting
    'blockquote',
    'br',
    'code',
    'div',
    'em',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hr',
    'i',
    'img',
    'li',
    'ol',
    'p',
    'pre',
    'span',
    'strike',
    'strong',
    'sub',
    'sup',
    'table',
    'tbody',
    'td',
    'th',
    'thead',
    'tr',
    'u',
    'ul',
    'a',
  ],
  KEEP_CONTENT: true,
  RETURN_DOM: false,
  RETURN_DOM_FRAGMENT: false,
  WHOLE_DOCUMENT: false,
  ADD_URI_SAFE_ATTR: ['src'],
};

/**
 * Sanitizes HTML content using DOMPurify with RichTextEditor-specific configuration
 * @param {string} content - The HTML content to sanitize
 * @returns {string} - Sanitized HTML content
 */
export const sanitizeRichText = (content) => {
  // Configure DOMPurify to allow data URLs for images
  DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
    if (node.nodeName === 'IMG' && data.attrName === 'src' && data.attrValue.startsWith('data:image/')) {
      // eslint-disable-next-line no-param-reassign
      data.forceKeepAttr = true;
    }
  });

  return DOMPurify.sanitize(content, RICH_TEXT_SANITIZE_CONFIG);
};

/**
 * Creates a sanitized display configuration for rendering HTML content
 * @param {string} content - The HTML content to sanitize and display
 * @returns {{ __html: string }} - HTML content
 */
export const createSanitizedHtml = (content) => ({
  __html: sanitizeRichText(content),
});
